import * as HeroStyles from '../dotdotdot/DotDotDotField.scss';
import * as React from 'react';
import { IconButton, ButtonType } from 'office-ui-fabric-react/lib/Button';

export interface IFollowedFieldProps {
  onClick: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  ariaLabel?: string;
  title?: string;
  hasFollowed?: boolean;
}

export const FollowedHeroField: React.StatelessComponent<IFollowedFieldProps> = (props: IFollowedFieldProps) => {
  let { onClick, isDisabled, ariaLabel, title, hasFollowed } = props;

  if (!isDisabled) {
    isDisabled = false;
  }

  const iconName = hasFollowed ? 'SingleBookmarkSolid' : 'SingleBookmark';
  return (
    <IconButton
      className={ `${HeroStyles.heroButton} ${HeroStyles.followHeroButton}` }
      onClick={ onClick }
      buttonType={ ButtonType.hero }
      aria-label={ ariaLabel }
      data-automationid='FieldRender-Followed'
      iconProps={
        { iconName: iconName }
      }
      title={ title }
    />
  );
};
